export default __webpack_public_path__ + "static/media/footerLogo.ee6c8f35.png";